import { render, staticRenderFns } from "./diff_comment_cell.vue?vue&type=template&id=2bcd228c"
import script from "./diff_comment_cell.vue?vue&type=script&lang=js"
export * from "./diff_comment_cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports